/**
 * QA auth exemption — email match only. No password. No secrets.
 * Lets the seeded internal account skip the client-side builder gate.
 */

import { EMPTY_DRAFT, type ProfileDraft } from './types';

export const QA_INTERNAL_EMAIL = 'qa@hottr.internal';

export function isQaInternalEmail(email: string | null | undefined): boolean {
  return (email ?? '').trim().toLowerCase() === QA_INTERNAL_EMAIL;
}

/** Enough fields that isDraftComplete passes even before completedAt short-circuit. */
export function qaInternalDraft(now = new Date().toISOString()): ProfileDraft {
  return {
    ...EMPTY_DRAFT,
    handle: 'qa_internal',
    displayName: 'QA',
    ageConfirmed: true,
    lookingForTonight: 'just_looking',
    wantsToSee: ['men'],
    location: 'Melbourne',
    interests: ['qa'],
    photos: ['qa/placeholder.jpg'],
    completedAt: now,
  };
}
